import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { EmpathySection } from '../components/sales/EmpathySection';
import { AgitationSection } from '../components/sales/AgitationSection';
import { RevelationSection } from '../components/sales/RevelationSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { NotThisSection } from '../components/sales/NotThisSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { ContentsSection } from '../components/sales/ContentsSection';
import { ForWhoSection } from '../components/sales/ForWhoSection';
import { CredibilitySection } from '../components/sales/CredibilitySection';
import { ObjectionsSection } from '../components/sales/ObjectionsSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { OfferSection } from '../components/sales/OfferSection';
import { CTASection } from '../components/sales/CTASection';
import { FAQSection } from '../components/sales/FAQSection';
import { ClosingSection } from '../components/sales/ClosingSection';
import { DisclaimerSection } from '../components/sales/DisclaimerSection';
import { FooterSection } from '../components/sales/FooterSection';
export function SalesPage() {
  return <main className="min-h-screen w-full font-sans text-gray-900 selection:bg-green-200" data-id="element-393">
      <HeroSection data-id="element-394" />
      <EmpathySection data-id="element-395" />
      <AgitationSection data-id="element-396" />
      <RevelationSection data-id="element-397" />
      <MechanismSection data-id="element-398" />
      <NotThisSection data-id="element-399" />
      <BenefitsSection data-id="element-400" />
      <ContentsSection data-id="element-401" />
      <ForWhoSection data-id="element-402" />
      <CredibilitySection data-id="element-403" />
      <ObjectionsSection data-id="element-404" />
      <GuaranteeSection data-id="element-405" />
      <OfferSection data-id="element-406" />
      <CTASection data-id="element-407" />
      <FAQSection data-id="element-408" />
      <ClosingSection data-id="element-409" />
      <DisclaimerSection data-id="element-410" />
      <FooterSection data-id="element-411" />
    </main>;
}